/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbResourceType {
    getFixupPrototypeFunction() { return ServiceNowCmdbResourceType.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbResourceType>): ServiceNowCmdbResourceType {
        let obj = Object.assign(new ServiceNowCmdbResourceType(), model);
        ServiceNowCmdbResourceType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbResourceType>): ServiceNowCmdbResourceType {
        if (!model) return null;
        return ServiceNowCmdbResourceType.newInstance(<ServiceNowCmdbResourceType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbResourceType) {
        if (!obj) return;

        models.ServiceNowCmdbResourceType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbResourceType): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbResourceType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the Resource Type
     */
    resource_type: string;

    /**
     * List of Resource
     */
    resources: Array<string>;

}
